<template>
	<div class="full-image" v-if="show" @click.self="close" :modal="true">
		<div class="mask" @click="close"></div>
		<div class="toolbar">
			<div class="tool-btn" @click="zoomIn" title="放大">
				<i class="el-icon-zoom-in"></i>
			</div>
			<div class="tool-btn" @click="zoomOut" title="缩小">
				<i class="el-icon-zoom-out"></i>
			</div>
			<div class="tool-btn" @click="resetView" title="重置">
				<i class="el-icon-refresh"></i>
			</div>
			<div class="tool-btn close-btn" @click="close" title="关闭">
				<i class="el-icon-close"></i>
			</div>
		</div>
		<div class="image-container" ref="container"
			@wheel.prevent="handleWheel"
			@mousedown="startDrag"
			:class="{ dragging: isDragging }">
			<img :src="url" ref="image"
				:style="imageStyle"
				@load="onImageLoad" />
		</div>
		<div class="scale-info">{{ Math.round(scale * 100) }}%</div>
	</div>
</template>

<script>
export default {
	name: "fullImage",
	data() {
		return {
			show: false,
			url: '',
			scale: 1,
			positionX: 0,
			positionY: 0,
			isDragging: false,
			dragStartX: 0,
			dragStartY: 0,
			lastPositionX: 0,
			lastPositionY: 0
		}
	},
	computed: {
		imageStyle() {
			return {
				transform: `translate(${this.positionX}px, ${this.positionY}px) scale(${this.scale})`,
				cursor: this.isDragging ? 'grabbing' : 'grab'
			}
		}
	},
	methods: {
		open(url) {
			this.show = true;
			this.url = url;
			this.resetView();
		},
		close() {
			this.show = false;
			this.resetView();
		},
		resetView() {
			this.scale = 1;
			this.positionX = 0;
			this.positionY = 0;
		},
		zoomIn() {
			this.scale = Math.min(this.scale + 0.25, 5);
		},
		zoomOut() {
			this.scale = Math.max(this.scale - 0.25, 0.1);
		},
		handleWheel(e) {
			if (e.deltaY < 0) {
				this.zoomIn();
			} else {
				this.zoomOut();
			}
		},
		startDrag(e) {
			if (e.button !== 0) return;
			this.isDragging = true;
			this.dragStartX = e.clientX - this.lastPositionX;
			this.dragStartY = e.clientY - this.lastPositionY;
			window.addEventListener('mousemove', this.onDrag);
			window.addEventListener('mouseup', this.stopDrag);
		},
		onDrag(e) {
			if (!this.isDragging) return;
			this.positionX = e.clientX - this.dragStartX;
			this.positionY = e.clientY - this.dragStartY;
		},
		stopDrag() {
			this.isDragging = false;
			this.lastPositionX = this.positionX;
			this.lastPositionY = this.positionY;
			window.removeEventListener('mousemove', this.onDrag);
			window.removeEventListener('mouseup', this.stopDrag);
		},
		onImageLoad() {
			this.resetView();
		}
	}
}
</script>

<style lang="scss" scoped>
.full-image {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 9999;

	.mask {
		position: fixed;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.9);

	}

	.toolbar {
		position: fixed;
		top: 20px;
		right: 20px;
		display: flex;
		gap: 8px;
		z-index: 10001;

		.tool-btn {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 40px;
			height: 40px;
			background: rgba(255, 255, 255, 0.1);
			border: 1px solid rgba(255, 255, 255, 0.2);
			border-radius: 8px;
			cursor: pointer;
			transition: all 0.3s ease;

			i {
				font-size: 20px;
				color: #fff;
			}

			&:hover {
				background: rgba(255, 255, 255, 0.2);
			}

			&.close-btn {
				background: rgba(244, 67, 54, 0.8);
				border-color: rgba(244, 67, 54, 1);

				&:hover {
					background: rgba(244, 67, 54, 1);
				}
			}
		}
	}

	.image-container {
		position: fixed;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10000;

		img {
			max-height: 100%;
			max-width: 100%;
			transition: transform 0.1s ease;
			user-select: none;
			-webkit-user-drag: none;
		}

		&.dragging {
			cursor: grabbing;

			img {
				transition: none;
			}
		}
	}

	.scale-info {
		position: fixed;
		bottom: 20px;
		left: 50%;
		transform: translateX(-50%);
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		padding: 8px 16px;
		border-radius: 20px;
		font-size: 14px;
		z-index: 10001;
	}
}
</style>